import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { theme } from "../theme.js";
import { getOrgIdFromStorage } from "../utils/storage.js";
import {UserCircleIcon, Bars3Icon} from '@heroicons/react/24/outline';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const orgId = getOrgIdFromStorage();

  const goToConnexion = () => {
    console.log("User info:", localStorage.getItem("user"));
    if (localStorage.getItem("user")) {
      window.location.href = "/user";
      return;
    }
    else {
      window.location.href = "/login";
    }
  };

  return (
    <header style={{...styles.header, top: orgId ? 40 : 0}}>
      <div style={styles.container}>
        {/* Logo */}
        <h1 style={{ ...styles.logoTitle, cursor: "pointer" }} onClick={() => window.location.href = "/"}>DNS</h1>

        {/* Right side: Profile + Burger Menu */}
        <div style={styles.rightSection}>
          <button style={styles.profileButton} title="Go to profile" onClick={goToConnexion}>
            <UserCircleIcon style={styles.icon} />
          </button>
        </div>
      </div>
    </header>
  );
}

const styles = {
  header: {
    backgroundColor: theme.colors.bgDark,
    position: "sticky",
    left: 0,
    right: 0,
    zIndex: theme.zIndex.sticky,
    boxShadow: theme.shadows.md,
    borderBottom: `1px solid rgba(182, 244, 0, 0.1)`,
  },
  container: {
    maxWidth: "100%",
    margin: "0 auto",
    padding: `${theme.spacing.lg} ${theme.spacing.lg}`,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.lg,
    width: "100%",
    justifyContent: "space-between",
  },
  logo: {
    flex: 0,
    minWidth: "80px",
    order: 1,
  },
  logoTitle: {
    margin: 0,
    fontSize: theme.fonts.size.huge,
    fontWeight: theme.fonts.weight.light,
    color: theme.colors.textLight,
    fontFamily: theme.fonts.family.logo,
  },
  rightSection: {
    display: "flex",
    gap: theme.spacing.md,
    alignItems: "center",
    flex: 0,
    order: 3,
  },
  icon: {
    width: "40px",
    height: "40px",
    color: theme.colors.light,
    strokeWidth: 1.5,
  },
  profileButton: {
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    transition: `all ${theme.transitions.base}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
  },
  burgerButton: {
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    transition: `all ${theme.transitions.base}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
  },
  mobileMenu: {
    backgroundColor: theme.colors.bgLight,
    borderTop: `1px solid rgba(182, 244, 0, 0.1)`,
    boxShadow: theme.shadows.lg,
    padding: `${theme.spacing.md} ${theme.spacing.lg}`,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.md,
    position: "absolute",
    top: "100%",
    right: theme.spacing.md,
    width: "200px",
    zIndex: theme.zIndex.dropdown,
    borderRadius: theme.radius.md,
  },
  mobileLink: {
    color: theme.colors.dark,
    textDecoration: "none",
    fontSize: theme.fonts.size.md,
    fontWeight: theme.fonts.weight.medium,
    padding: `${theme.spacing.md} 0`,
    transition: `color ${theme.transitions.base}`,
  },
};
